import React from "react";
import PropTypes from "prop-types";
import RecommendedInPlayerContainer from "./styles/RecommendedInPlayer.style";
import { createBoxes } from "../../../../helpers";
import { isMobile, isTablet } from "react-device-detect";

let recommendedVideos = isMobile ? 1 : 6;

const RecommendedInPlayer = (props) => (
  <RecommendedInPlayerContainer>
    {!isMobile && !isTablet && (
      <div className="rc">
        {createBoxes(
          {
            videos: props.recommended.slice(0, recommendedVideos).map((it) => it),
            user: props.user,
            auth: props.auth,
            methods: {
              addFavorite: props.addFavorite,
              removeFavorite: props.removeFavorite,
              addToCart: props.addToCart,
              removeFromCart: props.removeFromCart
            }
          },
          "recommendations"
        )}
      </div>
    )}
  </RecommendedInPlayerContainer>
);

RecommendedInPlayer.propTypes = {
  user: PropTypes.shape().isRequired,
  auth: PropTypes.shape().isRequired,
  addFavorite: PropTypes.func.isRequired,
  removeFavorite: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired
};

export default RecommendedInPlayer;
